export const ID = 'ef55d0bb-44db-42aa-b037-e462d4785110';

export const NAME = 'Units Table: StorageMart (legacy)';
